import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges, ViewChild, ViewEncapsulation} from '@angular/core';
import {DemoService, MyobAuthStatus} from '../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { environment } from './../../../environments/environment';

import { Job } from '../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';


// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {delay, Observable, retry, Subject} from 'rxjs';
import { map, filter } from 'rxjs';
import { GlobalFunctionsService } from './../../services/global-functions.service';
import { TabsetComponent } from 'ngx-bootstrap';


@Component({
  selector: 'app-myob-login',
  templateUrl: './myob-login.component.html',
  styleUrls: ['./myob-login.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class MyobLoginComponent implements OnInit {
  currentUserVAR: any;
  sessionUserId: any;
  sessionBrandId: any;
  myobCode: any;
  code: any;
  myobCustomers: any;

  arrCase: object [];
  Items: any [];
  Address: object [];
  session_code: any;
  myob_checker: MyobAuthStatus;
  myob_response: boolean;
  myob_checking = false;
  myob_refreshing = false;
  myob_status_error: string;
  readonly myob_revoke_url = 'https://secure.myob.com/';
  post_new_approved_invoices_result: Object;
  post_new_approved_customers_result: Object;
  response_from_node: any;

    // TABS sets the selected
    @ViewChild('staticTabs') staticTabs: TabsetComponent;

  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
    public gfunc: GlobalFunctionsService
  ) { 


 // login vars
 this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser'));
 console.log('sessionUserId: ', this.currentUserVAR.user_id );
 console.log('sessionUsername: ', this.currentUserVAR.username );
 // Set loggind in User Value (USER ID)
 this.sessionUserId = this.currentUserVAR.user_id;
 this.sessionUserId = this.currentUserVAR.username;
 this.sessionBrandId = this.currentUserVAR.brand_id;

 if (sessionStorage.getItem('access_code')) {
 this.session_code = JSON.parse(sessionStorage.getItem('access_code'));
}

  }

  ngOnInit() {

  //  this.getMyobCustomers();
  //  this.getMyobCode();

  this.myob_response = false;
 
// 07/02/24 -- Removed the Myob Checker From the Page Load and moving to function model... so only checking when needed to pervent loading errors when using mulitple paymens

              this.myobChecker();

              
              
              //  // API CALL IN NODE TO GET THE CUSTOMERS (see node.js app)
              // //  this.getMyobCustomers();

              // let params = new HttpParams();
              // params.get('code');
              // // console.log(params.get('code'));


   this.route.queryParams
   .pipe(filter(params => params.code))
   .subscribe(params => {
     console.log(params); // { order: "popular" }

     this.code = params.code;
     sessionStorage.setItem('access_code', JSON.stringify(this.code));
    // console.log(this.code); // popular
   }
 );



  }

getMyobCode(){
  this._demoService.getMyobCode().subscribe(
    data => { this.myobCode = data;
      this.toastr.success('MYOB handshake: shaken..! SOP we are connected...');

    },
    err => console.error(err),
    () =>  this.toastr.error('You need to login to MYOB again, Connection lost!')
  );

}


// uses demo services but calls to myob
getMyobCustomers(){
  this._demoService.getMyobCustomers().subscribe(
    data => { this.myobCustomers = data;
      let res = data[0];

       console.log(this.myobCustomers);

       // https://www.concretepage.com/questions/577
       this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
       // console.log(this.arrCase);
       this.Items = data['Items'] ;
       console.log(this.Items);
      // this.Address = this.Items['Address'];




    },
    err => {
      // this.toastr.error('You need to login to MYOB again, Connection lost!');
      console.error(err);
    },
    // () => console.log('done loading Trace Types')
  );

}




get myob_authorisation_url(): string {
  return this.gfunc.sopNodeURL + '/api/myob/oauth/granular/start';
}

get myob_connection_ready(): boolean {
  return Boolean(
    this.myob_checker &&
    this.myob_checker.connected &&
    this.myob_checker.granularReady &&
    this.myob_checker.businessIdMatches
  );
}

myobChecker() {
  this.myob_checking = true;
  this.myob_status_error = null;
  this._demoService.getMyobAuthStatus()
  // .pipe(
  //   this.toastr.observe({
  //     loading: 'Checking...',
  //     success: '🚀...success',
  //     error: '😡... MYOB not Taklking...Please Login or try again.'
  //  })
  //  )
  .pipe(
    retry(2), // you retry 3 times
    delay(1500) // each retry will start after 1 second,
 )
  .subscribe(
     data => { this.myob_checker = data;
      this.myob_response = this.myob_connection_ready;
      this.myob_checking = false;
      // this.toastr.success('Myob Connections Active!... functions allowed');
// console.log('Connected: ', JSON.stringify(this.myob_checker));
            // if (res){    
            // this.myob_response = true
            // }
    },
     err => (
      // this.toastr.success('Myob Connections Not Active! Please connect again.', err.error),
      this.myob_response = false,
      this.myob_checking = false,
      this.myob_status_error = 'The MYOB connection status could not be loaded.',
      console.error(err)
     ),
     // () => console.log('done loading Trace Types')
   );
 }

refreshMyobTokens() {
  if (this.myob_refreshing) {
    return;
  }

  this.myob_refreshing = true;
  this.myob_status_error = null;
  this._demoService.refreshMyobTokens().subscribe({
    next: result => {
      this.myob_checker = result;
      this.myob_response = this.myob_connection_ready;
      this.myob_refreshing = false;
      this.toastr.success('MYOB access and refresh tokens were rotated and saved.');
    },
    error: err => {
      this.myob_refreshing = false;
      if (err.error && err.error.requiresAuthorisation && this.myob_checker) {
        this.myob_checker.connected = false;
      }
      this.myob_response = this.myob_connection_ready;
      this.myob_status_error = err.error && err.error.error ?
        err.error.error : 'MYOB tokens could not be refreshed.';
      this.toastr.error(this.myob_status_error);
      console.error(err);
    }
  });
}



//  MYOB NODE JS BULK ACTIONS AS A FUNCTION






postNewApprovedContactsCustomers() {
  this.http.get(this.gfunc.sopNodeURL + '/postNewApprovedContactsCustomers')
  .pipe(
    this.toastr.observe({
      loading: 'Checking... Action: postNewApprovedContactsCustomers...',
      success: '🚀...weeeeeee',
      error: '...😡...'
   })
   )
  .pipe(
    retry(0), // you retry 3 times
    delay(1500) // each retry will start after 1 second,
 ).subscribe(
  data => { this.post_new_approved_customers_result = data;}
 );




  // .subscribe(
  //    data => { this.post_new_approved_customers_result = data;
  //     let res = data[0];
  //           // console.log('Connected: ', JSON.stringify(this.myob_checker));
  //   },
  //    err => (
  //     this.toastr.success('We encounted issues please contact the system administrator.', err.error),
  //     console.error(err)
  //    ),
  //   //  () =>{
  //   //   this.toastr.success('Action: postNewApprovedContactsCustomers... functions completed. ')

  //   //  }
  //  );
 }









 postNewApprovedInvoices() {
  // this.http.get(this.gfunc.sopNodeURL + '/postNewApprovedInvoices')
  this.http.get(this.gfunc.sopNodeURL + '/postNewInvoicePayments/fromTSA')
  .pipe(
    this.toastr.observe({
      loading: ' ... ',
      success: '🚀',
      error: '😡 ...'
   })
   )
  .pipe(
    retry(0), // you retry 3 times
    delay(1500) // each retry will start after 1 second,
 )
  .subscribe(
     data => { this.post_new_approved_invoices_result = data;
      let res = data[0];
            // console.log('Connected: ', JSON.stringify(this.myob_checker));

          console.log('Node Is Saying: " ' + JSON.stringify(res) + ' " ');
          this.response_from_node = JSON.stringify(data);
    },
     err => (
      this.toastr.success('We encounted issues please contact the system administrator.', err.error),
      console.error(err),
      this.response_from_node = JSON.stringify(err)
     ),
    //  () =>{
    //   console.log('done loading Trace Types');
    //   this.toastr.success('Action: postNewApprovedInvoices... functions completed. ')

    //  }
   );
 }







// @@  https://stackoverflow.com/questions/14220321/how-do-i-return-the-response-from-an-asynchronous-call
// This is isn't declared as `async` because it already returns a promise
delay() {
  // `delay` returns a promise
  return new Promise(function(resolve, reject) {
    // Only `delay` is able to resolve or reject the promise
    setTimeout(function() {
      resolve(42); // After 3 seconds, resolve the promise with value 42
    }, 3000);
  });
}
  // wait for 3 seconds (just for the sake of this example)
  // await delay();


  /// TABS
  selectTab(tab_id: number) {
    this.staticTabs.tabs[tab_id].active = true;
    // this.join_results = null; // refresh the model when a tab is clicked.?
    };
    



 refreshPage() { // refresh the databutton
this.gfunc.myobChecker(); // just check tokens
  // this.grid.refresh();
};

}
